export const RESET_STORE = 'core/RESET_STORE'
export const resetStore = () => ({ type: RESET_STORE })
